import {clsx} from 'external/clsx'
import { useMemo, Link} from 'external/react'

import ButtonBack from 'components/ButtonBack'
import usePublic from 'context/public-context/hook'

export default function LanguageBar() {

    const {navigation, offerData: {courses : offerCourses = []}, query: {languageId, fromCart}, params} = usePublic()

    const backLink = useMemo(() => navigation.offerCourses.active && navigation.offerSubjects.linkWithQuery({languageId}, true), [navigation])

    const [toES, toEN] = useMemo(() =>
        navigation.offerCourses.active
            ? [ navigation.offerCourses.linkWithQuery({languageId: 'es'}),
                navigation.offerCourses.linkWithQuery({languageId: 'en'})]
            : []
        , [navigation])
    
    const [englishCount, spanishCount] = useMemo(() => {
        const english = offerCourses.filter(({subject, language}) => subject == params.idSubject && language === 'en').length
        const spanish = offerCourses.filter(({subject, language}) => subject == params.idSubject && language === 'es').length
        return [english, spanish]
    }, [offerCourses, params.idSubject])

	return (
        <div className='bodyHeader_subject'>
            {!fromCart && <ButtonBack path={backLink} />}
            {fromCart && <div/>}
            <div>
                {spanishCount > 0 && (<Link to={toES} className={clsx('language__filter', 'mx-1', {selected: languageId === 'es'})}>Español</Link>)}
                {englishCount > 0 && (<Link to={toEN} className={clsx('language__filter', 'mx-1', {selected: languageId === 'en'})}>Inglés</Link>)}
            </div>
        </div>
    )
}